import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SFFaqComponent from "./component";

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = ({
    sfLandingPageData: {
        sfLandingPageData: { faqList }
    }
}) => ({
    faqList
});

export default connect(mapStateToProps, mapDispatchToProps)(SFFaqComponent);
